const common = {
  marketStatus: {
    CN: {
      '-1': '',
      1: '无效状态',
      2: '开市',
      3: '交易中',
      4: '收市',
      5: '休市',
      6: '停牌',
      7: '集合竞价',
      8: '熔断',
      9: '日间竞价',
      10: '尾盘竞价',
      11: '非活跃',
      12: '盘前交易',
      13: '盘后交易',
      14: '日间闭市',
      15: '报价阶段',
      16: '停牌一小时',
      17: '停牌一天',
      18: '连续停牌',
      19: '盘中停牌',
      20: '停牌半天',
      21: '暂停',
    },
    GMG: {
      '-1': '',
      1: '开市中',
      2: '开市中',
      3: '交易中',
      4: '已收盘',
      5: '午间休市',
      6: '停牌中',
      7: '集合竞价中',
      8: '熔断中',
      9: '日间竞价',
      10: '集合竞价中',
      11: '',
      12: '已收盘',
      13: '已收盘',
      14: '已收盘',
      15: '报价',
      16: '停牌',
      17: '停牌',
      18: '停牌',
      19: '停牌',
      20: '停牌',
      21: '停牌',
    },
    USA: {
      1: '收盘',
      5: '交易中'
    }
  }, 
}

const diff = {
  dev: {

  },
  production: {

  }
}[process.env.NODE_ENV]

export default Object.assign(common, diff)
